var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3333 39.168H8.66667C4.98477 39.168 2 42.1527 2 45.8346V55.8346C2 59.5165 4.98477 62.5013 8.66667 62.5013H55.3333C59.0152 62.5013 62 59.5165 62 55.8346V45.8346C62 42.1527 59.0152 39.168 55.3333 39.168Z",
    stroke: "#FAFAFA",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 4.16797H8.66667C6.89856 4.16797 5.20286 4.87035 3.95262 6.12059C2.70238 7.37083 2 9.06653 2 10.8346V20.8346C2 22.6027 2.70238 24.2984 3.95262 25.5487C5.20286 26.7989 6.89856 27.5013 8.66667 27.5013H25.3333",
    stroke: "#FAFAFA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6663 29.1667C56.0301 29.1667 61.9997 23.1971 61.9997 15.8333C61.9997 8.46954 56.0301 2.5 48.6663 2.5C41.3025 2.5 35.333 8.46954 35.333 15.8333C35.333 23.1971 41.3025 29.1667 48.6663 29.1667Z",
    stroke: "#FAFAFA",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.667 20.832C51.4284 20.832 53.667 18.5935 53.667 15.832C53.667 13.0706 51.4284 10.832 48.667 10.832C45.9056 10.832 43.667 13.0706 43.667 15.832C43.667 18.5935 45.9056 20.832 48.667 20.832Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service3.13a52e688d49fbf26c80cdb43f75f9e0.svg";
export { ForwardRef as ReactComponent };